import React from 'react';
import {InferPropTypes} from 'commons/types/Types';
import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';
import InnerFormRepresentativePower from './InnerFormRepresentativePower';
import {AddressProofValues} from 'commons/models';
import {formValidator} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';
import {FieldShape} from 'commons/shapes';

RepresentativePowerForm.propTypes = {
    foreign: PropTypes.bool.isRequired,
    personType: PropTypes.string.isRequired,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    document: PropTypes.any
};

const FormControl = withFormik<
    InferPropTypes<typeof RepresentativePowerForm.propTypes>,
    AddressProofValues
>({
    mapPropsToErrors: () => {
        return {
            file: '',
        };
    },
    mapPropsToValues: (props) => {
        return {
            file: props.document || '',
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
    validate: (values: AddressProofValues, props) => {
        const errors: FormikErrors<AddressProofValues> = {};
        formValidator(props.fields, errors, values);
        if (!values.file) {
            errors.file = Messages.FILE_NOT_SELECTED;
        }
        return errors;
    },
})(InnerFormRepresentativePower);

function RepresentativePowerForm(props: InferPropTypes<typeof RepresentativePowerForm.propTypes>) {
    const {submitHandler, fields, personType, foreign, document} = props;

    return (
        <FormControl
            fields={fields}
            foreign={foreign}
            personType={personType}
            document={document}
            // eslint-disable-next-line react/jsx-handler-names
            submitHandler={submitHandler}
        />
    );
}
export default RepresentativePowerForm;
